export interface SessionState {
  showLogoutWarning: boolean;
}

class SessionManager {
  private state: SessionState = {
    showLogoutWarning: false,
  };

  private listeners: Array<(state: SessionState) => void> = [];

  subscribe(callback: (state: SessionState) => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(
        (listener) => listener !== callback,
      );
    };
  }

  private notifyListeners() {
    this.listeners.forEach((listener) => listener(this.state));
  }

  private updateState(updates: Partial<SessionState>) {
    this.state = { ...this.state, ...updates };
    this.notifyListeners();
  }

  showLogoutWarning() {
    this.updateState({ showLogoutWarning: true });
  }

  triggerLogout() {
    this.updateState({ showLogoutWarning: false });

    import("../services/user").then(({ logoutUser }) => {
      logoutUser();
    });
  }

  getState(): SessionState {
    return { ...this.state };
  }

  hideLogoutWarning() {
    this.updateState({ showLogoutWarning: false });
  }
}

export const sessionManager = new SessionManager();
